<template>
  <div class="nj-grid">
    <nj-question-dialog
      ref="removeQuestionDialog"
      title="Excluir Assinatura do Médico"
      text="Deseja realmente excluir a assinatura do médico?"
    />
    <div class="header">
      <v-form @submit.prevent="search()">
        <div class="d-flex flex-row">
          <nj-chip-select-input
            class="mr-2"
            default-text="Empresa"
            :items="branches"
            v-model="form.branch"
          ></nj-chip-select-input>
          <nj-chip-select-input
            class="mr-2"
            default-text="Médico"
            :items="doctors"
            v-model="form.doctor"
          ></nj-chip-select-input>
        </div>
      </v-form>
      <v-btn
        small
        color="primary"
        title="Nova Assinatura do Médico"
        elevation="0"
        to="/doctor_signatures/new"
      >
        <v-icon left> mdi-plus </v-icon>
        Novo
      </v-btn>
    </div>
    <v-data-table
      :headers="headers"
      :items="items"
      class="nj-table"
      :loading="loading"
      :options.sync="options"
      loading-text="Buscando..."
      ref="dataTable"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:item.updated_at="{ item }">
        {{ item.updated_at | njDateFormat(null, 'DD/MM/YYYY HH:mm') }}
      </template>
      <template v-slot:item.controls="{ item }">
        <div style="width: 160px">
          <v-btn
            :to="{ name: 'DoctorSignatureShow', params: { id: item.id } }"
            title="Visualizar"
            icon
          >
            <v-icon color="green">mdi-eye</v-icon>
          </v-btn>
          <v-btn
            :to="{ name: 'DoctorSignatureEdit', params: { id: item.id } }"
            title="Editar"
            icon
          >
            <v-icon color="orange">mdi-square-edit-outline</v-icon>
          </v-btn>
          <v-btn @click="remove(item)" title="Remover" icon>
            <v-icon color="red">mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import Api from '@/resources/NajaSocialApi'
// import OutboxEnum from '@/enumerations/task_scheduler_enum'

export default {
  name: 'DoctorSignatures',
  data: () => ({
    loading: false,
    items: [],
    operations: [],
    options: {},
    doctors: [],
    branches: [],
    form: {
      doctor: null,
      branch: null,
    },
    headers: [
      { text: 'Empresa', value: 'branch_name' },
      { text: 'Médico', value: 'doctor_name' },
      { text: 'Última modificação', value: 'updated_at' },
      { text: 'Ações', value: 'controls', sortable: false },
    ],
  }),

  mounted() {
    this.search()
    this.fetch()
  },

  watch: {
    form: {
      handler() {
        this.search()
      },
      deep: true,
    },
  },

  methods: {
    async fetch() {
      try {
        const branchesResult = await Api.branches()
        this.branches = branchesResult.data.branches.map(branch => {
          return { value: branch.id, text: branch.name }
        })

        const doctorsResult = await Api.organization.doctors()
        this.doctors = doctorsResult.data.doctors.map(doctor => {
          return { value: doctor.id.toString(), text: doctor.name }
        })
      } catch (error) {
        this.$root.$children[0].toast('Erro ao buscar dados')
        throw error
      }
    },

    remove(item) {
      if (!this.$hasPermission('naja_app_roles_destroy')) {
        alert('Acesso negado')
        return
      }

      this.$refs.removeQuestionDialog.open({
        onConfirm: () => {
          this.$refs.removeQuestionDialog.toggleLoading()
          Api.doctorSignatures
            .destroy(item.id)
            .then(() => {
              this.search()
            })
            .catch(error => {
              if (error.response) {
                // this.$toast.show('Erro ao remover caixa de saída', 'error')
              } else {
                throw error
              }
            })
            .finally(() => {
              this.$refs.removeQuestionDialog.close()
            })
        },
      })
    },

    search() {
      this.loading = true

      const query = {
        q: {
          s: ['created_at desc'],
          doctor_id_eq: this.form.doctor,
          organization_branch_id_eq: this.form.branch,
        },
      }

      Api.doctorSignatures
        .search(query)
        .then(response => {
          this.items = response.data.doctor_signatures
        })
        .catch(error => {
          throw error
        })
        .finally(() => {
          this.loading = false
          this.$scrollTop()
        })
    },
  },
}
</script>
